import State from './State';
import GameModel from '../GameModel';
import * as PIXI from 'pixi.js';
import {Countdown} from '../Countdown';
import HudRenderer from 'src/Pixi/HudRenderer';

import Text = PIXI.Text;

export default class EndState extends State {
    private countdown: Countdown;
    private result: Text;

    public start(): void {
        this.countdown = new Countdown(5, 'Game ends in');
        this.countdown.start();

        const style = new PIXI.TextStyle({
            fontFamily: 'Arial',
            fontSize: 32,
            fill: 0xffffff,
            align: 'center',
        });
        const text = this.resultText();
        this.result = new Text(text, style);
        const metrics = PIXI.TextMetrics.measureText(text, style);
        this.result.position.set(
            window.innerWidth / 2 - metrics.width / 2,
            window.innerHeight / 2 - metrics.height / 2
        );
        GameModel.uiContainer.addChild(this.result);
    }

    public finish(): void {
        this.countdown.finish();
        GameModel.uiContainer.removeChild(this.result);
        HudRenderer.endGame();
    }

    public tick(): void {
        this.countdown.tick();
    }

    private resultText(): string {
        const heldCounts = this.game.map.countHeldSpawns();
        if (this.isDraw(heldCounts)) {
            return "It's a draw!";
        } else {
            const winner = this.game.players.find(player => {
                return !!heldCounts.get(player.index);
            });
            if (winner) {
                return `${winner.name} wins!`;
            } else {
                return 'No one wins!';
            }
        }
    }

    private isDraw(heldCounts: Map<number, number>): boolean {
        let count = 0;
        this.game.players.forEach(player => {
            if ((heldCounts.get(player.index) || 0) > 0) {
                count += 1;
            }
        });
        return count > 1;
    }
}



// WEBPACK FOOTER //
// ./src/game/states/EndState.ts